export default __webpack_public_path__ + "static/banner-renovation-best-indoor-plants-0cabecd51ddbdc97a56094eba469e65d.jpg";